import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { OwnerIdFragmentGql } from './OwnerIdFragmentGql';

// Should fetch same nodes as DatabaseDownstreamOwnersFilteredByTableQuery
export const DatabaseDownstreamOwnerIdsFilteredByTableQueryGql: DocumentNode = gql`
query DatabaseDownstreamOwnerIdsFilteredByTableQuery($tableId: ID!, $first: Int!, $offset: Int!) {
  tables(filter: { id: $tableId }) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerIdFragment
      }
    }
  }
}
${OwnerIdFragmentGql}
`;
